<!-- @format -->

<template>
	<div class="p-6 container-medium m-auto mgs-centered-box">

		<img class="mb-10" alt="MGS logo" src="../assets/mgs.svg" />
		<base-form class="w-full" ref="form" :form-data="form" @submitted="login"></base-form>
		<p>
			Not yet registered? You can do so
			<router-link to="/register">Here</router-link>
		</p>
	</div>
</template>

<script>
/** @format */

export default {
	name: 'LoginUser',
	methods: {
		login(payload) {
			this.$store
				.dispatch('user/login', payload)
				.then(() => {
					this.$router.push({name: 'Dashboard'});
					this.$store.dispatch('notification/add', {type: 'success', message: 'You have logged in successfully.'});
				})
				.catch((error) => {
					this.$refs.form.submitting = false;
				});
		}
	},
	data() {
		return {
			form: [
				{
					name: 'email',
					label: 'Email',
					component: 'base-email'
				},
				{
					name: 'password',
					label: 'Password',
					component: 'base-password'
				}
			]
		};
	}
};
</script>
